export default "__VITE_PUBLIC_ASSET__a9a01fd4__"